import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import './user-list-container.styles.scss'
import { getAllUsersFromDb } from '@/utils/getAdminData';
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import UserIcon from '@/components/layout-auth/user-icon/user-icon.component';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import SearchBar from '@/components/SHARED/search-bar/search-bar.component';

const UserListContainer = ({
  owners
}) => {

  const [userList, setUserList] = useState(null);
  const [userCategory, setUserCategory] = useState('owners');
  let userListener;
  const userListRef = useRef({});
  const navigate = useNavigate();

  useEffect(() => {
    changeDocumentTitle('Gamably Admin | Manage Users');

    return () => {
      if (userListener) userListener();
    }
  }, [])

  useLayoutEffect(() => {
    if (!owners || !userCategory) return;
    if (userCategory === 'owners') {
      setUserList(owners);
    }
  }, [owners, userCategory])

  function search() {

  }

  return (
    <div className='user-list-container'>
      <div className='user-list g-card'>
        <div className='section-title with-icon'>
          <span>Manage Users</span>
          <button
            className='g-button med-btn'
            title="Create New User"
            onClick={() => navigate('/admin/users/create')}
          >
            Create New User
            <FontAwesomeIcon
              icon={faPlusCircle} />
          </button>
        </div>
        <hr />
        <div className='meta'>
          {userList ? Object.values(userList).length : 0} Users
        </div>
        <div className="g-space-1"></div>
        <div className='search-bar-container'>
          <SearchBar search={search} />
        </div>
        {
          (userList) &&
          <table className='g-table'>
            <thead>
              <tr>
                <th>Last Name</th>
                <th>First Name</th>
                <th>Email</th>
                <th>Created Games</th>
                <th>Joined</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                Object.values(userList).sort((a, b) => a.lName.toLowerCase() > b.lName.toLowerCase() ? 1 : -1)
                  .map(u => (
                    <tr key={u.appId}>
                      <td>{u.lName}</td>
                      <td>{u.fName}</td>
                      <td>{u.email}</td>
                      <td>{u.gamesCreated}</td>
                      <td>{format(new Date(u.ts_joined), 'Pp')}</td>
                      <td>
                        <button className='g-button small-btn'>
                          <FontAwesomeIcon 
                            icon={faPen}
                            onClick={() => navigate(`/admin/users/${u.appId}`)} />
                        </button>
                      </td>
                    </tr>
                  ))
              }
            </tbody>
          </table>
        }
      </div>
    </div>
  )
}

export default UserListContainer